module.exports = {
    "gameTime": 120,
}